<template>
  <vs-popup class="add-new-task" id="popup" :title="isCreateMode ? 'ADD TASK' : 'UPDATE TASK'" @close="open = false"
    :active.sync="open" :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="create-task-popup" @submit.prevent="handleSubmit(onClickCreateTask)" autocomplete="off">

          <div>
            <div class="mb-3 vx-row">
              <div class="w-full vx-col md:w-full md:mb-0">
                <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                  <vs-input v-model="form.name" label="Name" class="w-full" placeholder="Enter task name" />
                  <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>

            <div class="vx-row">
              <div class="vx-col w-full">
                <vs-tabs :value="active_step" class="tabs-shadow-none" alignment="center">
                  <vs-tab @click="setActiveStep(0)" label="Allocate a task to a department" class="tab-text"
                    icon-pack="feather" icon="icon-users">
                    <div class="vx-row mt-4">
                      <div class="vx-col w-full">
                        <small class="label">Create task specific to:</small>
                        <ul class="mt-2">
                          <li class="inline-block mr-4">
                            <vs-radio v-model="createType" vs-value="department">Departments</vs-radio>
                          </li>
                          <li class="inline-block mr-4">
                            <vs-radio v-model="createType" vs-value="users">Users</vs-radio>
                          </li>
                          <li class="inline-block mr-4">
                            <vs-radio v-model="createType" vs-value="both">Departments & Users</vs-radio>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- Department -->
                    <div v-if="createType == 'department' || createType == 'both'" class="vx-row mb-3">
                      <div class="vx-col md:w-full w-full md:mb-0">
                        <small class="label">Department</small>
                        <v-select name="department" v-model="form.departments" :options="departments" label="name"
                          :reduce="dept => dept.id" placeholder="Select Department" multiple :closeOnSelect="false" />
                      </div>
                    </div>
                    <div v-if="createType == 'users' || createType == 'both'" class="vx-row mb-3">
                      <div class="vx-col md:w-full w-full md:mb-0">
                        <!-- Staff -->
                        <small class="label">Assigned To</small>
                        <v-select :key="'staff-dropdown'" @search="onSearch" :clearable="true" name="staff"
                          placeholder="" label="name" v-model="form.staff" :reduce="option => option.id" multiple
                          :closeOnSelect="false" :options="staffs" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                          <template slot="no-options">
                            type to search staff
                          </template>
                        </v-select>
                      </div>
                    </div>

                    <!-- Frequency -->
                    <div class="vx-row mb-3">
                      <div class="vx-col md:w-full w-full md:mb-3">
                        <small class="label">Frequency</small>
                        <ul class="mt-2">
                          <li class="inline-block mr-4">
                            <vs-radio @change="setFrequency('One Off')" v-model="recurring" vs-value="once">One off
                              task</vs-radio>
                          </li>
                          <li class="inline-block mr-4">
                            <vs-radio @change="setFrequency(null)" v-model="recurring"
                              vs-value="recurring">Recurring</vs-radio>
                          </li>
                        </ul>
                        <v-select v-if="recurring == 'recurring'" name="frequencies" v-model="form.frequency"
                          :options="frequencies" :reduce="option => option.value" class="w-full">
                        </v-select>
                      </div>
                      <div v-if="isSelectableFrequency(form.frequency)" class="vx-col md:w-full w-full md:mb-3">
                        <small class="label">Scheduled Day/s</small>
                        <v-select name="weekdays" v-model="form.days_of_week" :options="weekdays"
                          :reduce="option => option.value" multiple :closeOnSelect="false" class="w-full"></v-select>
                      </div>
                    </div>
                  </vs-tab>
                  <vs-tab @click="setActiveStep(1)" label="Allocate a task to a system event" class="tab-text"
                    icon-pack="feather" icon="icon-sliders">
                    <!-- Allocation -->
                    <div class="vx-row mb-3">
                      <div class="vx-col md:w-full w-full md:mb-0">
                        <small class="label">Area</small>
                        <v-select name="allocations" v-model="form.allocation" :options=allocations
                          :reduce="option => option.value" placeholder="Select Allocation" />
                      </div>
                    </div>
                    <div class="vx-row mb-3 vx-card card-border no-shadow py-3 ml-0" v-if="form.allocation === 'Work Order'">
                      <div class="vx-col md:w-full w-full md:mb-0">
                        <small class="label">When</small>
                        <div class="vx-row">
                          <div class="vx-col w-1/2">
                            <small class="label">Status is</small>
                            <v-select name="event" v-model="form.allocation_event" :options=event_status[form.allocation]
                              :closeOnSelect="true" />
                          </div>
                          <div class="vx-col w-1/2">
                            <small class="label">FG Type is</small>
                            <v-select name="event" v-model="form.allocation_optional" :options=event_allocation_optional[form.allocation]
                              :closeOnSelect="true" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </vs-tab>
                </vs-tabs>
              </div>
            </div>


            <div v-if="recurring == 'recurring' || active_step == 1" class="vx-row mb-3 mt-3 vx-card card-border no-shadow ml-0 py-3">
              <small class="w-full vx-col label">Active Time Period</small>
              <div class="w-full vx-col md:w-1/2 md:mb-0">

                <small class="label">Start Date</small>
                <flat-pickr class="w-full" :config="flatPkrConfig" v-model="form.start_date"
                  placeholder="Choose Date" />
              </div>

              <div class="w-full vx-col md:w-1/2 md:mb-0">
                <small class="label flex items-center">No End Date <vs-checkbox class="pb-1"
                    style="margin-top: -0.25rem !important;" v-model="perpetual"></vs-checkbox></small>
                <flat-pickr v-if="perpetual == false" class="w-full" :config="flatPkrConfig" v-model="form.end_date"
                  placeholder="Choose Date" />
              </div>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="scheduled_task_template_id" name="scheduled_task_template_id" rules="required"
                v-slot="{ errors }">
                <small class="label">Task Template</small>
                <v-select :key="'template-dropdown'" @search="onSearchTemplate" :clearable="true" name="taskTemplate"
                  placeholder="" label="name" v-model="form.scheduled_task_template_id" :reduce="option => option.id"
                  :options="taskTemplates" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <template slot="no-options">
                    type to search templates
                  </template>
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="mb-3 vx-row  md:mb-0">
            <div class="w-full vx-col md:w-full md:mb-0">
              <small class="label">Notes</small>
              <vs-textarea v-model="form.notes" :rows="5"></vs-textarea>
            </div>
          </div>


          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="mt-2 ml-auto">Save Changes</vs-button>
            <vs-button @click="form = {}" class="mt-2 ml-4" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const DepartmentsRepository = RepositoryFactory.get('departments')
const ScheduledTasksRepository = RepositoryFactory.get('scheduled_tasks');
const DropDownRepository = RepositoryFactory.get('drop_down');

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import flatPickr from "vue-flatpickr-component";
import vSelect from 'vue-select'
function initialState() {
  return {
    open: false,
    id: '',
    form: {
      departments:[]
    },
    active_step: 1,
    staffs: [],
    taskTemplates: [],
    isCreateMode: true,
    createType: '',
    frequencies: [],
    allocations: [],
    departments: [],
    perpetual: true,
    recurring: 'once',
    weekdays: [
      { label: 'Monday', value: 1 },
      { label: 'Tuesday', value: 2 },
      { label: 'Wednesday', value: 3 },
      { label: 'Thursday', value: 4 },
      { label: 'Friday', value: 5 },
      { label: 'Saturday', value: 6 },
      { label: 'Sunday', value: 0 },
    ],
    event_status: {
      'Work Order': ['Open', 'Confirmed', 'Paused', 'Cancelled', 'In Progress', 'Stopped', 'Mix Completed', 'Pack Off In Progress', 'Pack Off Completed']
    },
    event_allocation_optional: {
      'Work Order': ['Liquid', 'Powder', 'Spray Dry Powder', 'Fruit']
    }
  }
}

export default {
  name: 'CreateTask',
  data() {
    return initialState()
  },
  components: {
    flatPickr,
    vSelect
  },
  methods: {
    async openPopup(data) {
      try {
        Object.assign(this.$data, initialState());

        await this.getFrequencies();
        await this.getAllocations();
        await this.getDepartments();
        await this.getStaffList(); 

        const { data: taskResponse } = await ScheduledTasksRepository.getTemplates(`filter[status]=Published`);
        this.taskTemplates = taskResponse.data;
        // this.$refs.form.reset();
        this.open = true;
        if (!!data) {
          this.id = data.id
          this.form = data
          this.form.staff = data.staff;
          this.form.scheduled_task_template_id = data.scheduled_task_template_id;
          this.isCreateMode = false
        } else {
          this.isCreateMode = true
          this.active_step = 0;
          this.form.frequency = 'One Off'
        }
      } catch (error) {

      }
    },
  searchStaff: _.debounce(async (loading, search, vm) => {
      loading(true);

      // Read departments from your form
      let deptsToSearch = vm.form.departments.map(item => {
      if(item.id){
        return item.id
      }
      else {
      return item
      }
      })
      const deptIds = Array.isArray(deptsToSearch)
        ? deptsToSearch.join(',')
        : '';

      let query = `filter[search]=${search}&filter[is_active]=1`;

      if (deptIds) {
        query += `&filter[department-ids]=${deptIds}`;
      }

      const { data } = await DropDownRepository.getStaffList(query);

      vm.staffs = data.data;
      loading(false);
    }, 350),
    async getStaffList(departmentIds = []) {
      let query = `filter[is_active]=1`;
      
      if (departmentIds.length > 0) {
        // example: filter[departments]=1,2,3
        query += `&filter[department-ids]=${departmentIds.join(',')}`;
      }
      const { data: staffResponse } = await DropDownRepository.getStaffList(query);

      this.staffs = staffResponse.data;
    },
    searchTemplates: _.debounce(async (loading, search, vm) => {
      const { data } = await ScheduledTasksRepository.getTemplates(`filter[search]=${search}&filter[status]=Published`)
      vm.taskTemplates = data.data
      loading(false);
    }, 350),
    async fetchTaskDetails() {
      await this.$vs.loading({
        container: '#create-task-popup',
        scale: 0.45
      })
      try {
        const { data } = (await ScheduledTasksRepository.getTask(this.id)).data
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-task-popup > .con-vs-loading')
    },
    async onClickCreateTask() {
      const vue = this;
      await this.$vs.loading({
        container: '#create-task-popup',
        scale: 0.45
      })
      try {
        if (this.isCreateMode) {
          await ScheduledTasksRepository.createTask(this.form);
          this.showSuccessMessage('Task added successfully');
        } else {
          await ScheduledTasksRepository.updateTask(this.id, this.form);
          this.showSuccessMessage('Task updated successfully');
        }
        await vue.$parent.refreshData();
        this.open = false;
      } catch (e) {
        this.$vs.loading.close('#create-task-popup > .con-vs-loading')
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#create-task-popup > .con-vs-loading')
    },
    onSearch(search, loading) {
      // if(search.length) {
      loading(true);
      this.searchStaff(loading, search, this);
      // }
    },
    onSearchTemplate(search, loading) {
      if (search.length) {
        loading(true);
        this.searchTemplates(loading, search, this);
      }
    },
    async getFrequencies() {
      try {
        const { data } = await ScheduledTasksRepository.frequencies();
        this.frequencies = data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load frequencies:", err);
      }
    },
    async getAllocations() {
      try {
        const { data } = await ScheduledTasksRepository.allocations();
        // create a new array so Vue detects the change
        this.allocations = data.data.sort((a, b) => a.label.localeCompare(b.label));
      } catch (err) {
        console.error("Failed to load allocations:", err);
      }
    },
    async getDepartments() {
      const { data } = await DepartmentsRepository.getListNoPagination()
      this.departments = data.data
    },
    isSelectableFrequency(frequency) {
      const allowedFrequencies = [
        'Daily',
        'Weekly',
        'Every 2 Weeks',
      ];

      return allowedFrequencies.includes(frequency);
    },
    setActiveStep(step) {
      this.active_step = step;
    },
    setFrequency(value) {
      this.form = { ...this.form, frequency: value };
    }
  },
  watch: {
  'form.departments': {
    async handler(newVal) {
      // Reset selected staff if needed
      // this.form.staff = null;

      let deptsToSearch = newVal.map(item => {
      if(item.id){
        return item.id
      }
      else {
      return item
      }
      })
      // Call your API
      await this.getStaffList(deptsToSearch);
    },
    deep: true
  }
  },
  computed: {
    flatPkrConfig() {
      return {
        dateFormat: 'd/m/Y',
      }
    }
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
.add-new-task>>>.vs-popup {
  /*min-height: 50% !important;*/
  min-width: 30% !important;
}



.con-vs-tabs {
  overflow: visible;

}

.con-vs-tabs>>>.con-slot-tabs {
  overflow: visible;
}

.con-vs-tabs .con-slot-tabs .con-tab {
  padding: 10px 0 0 0;
}
</style>
